import { Icon } from "../Icon.js";
import generic_pharmacy_default from "../static/generic-pharmacy.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconGenericPharmacy.tsx
/* istanbul ignore file -- @preserve */
const IconGenericPharmacy = ({ color, height, style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: generic_pharmacy_default,
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconGenericPharmacy };